var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTw(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 44,
    viewBox: "0 0 44 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 44,
    height: 44,
    rx: 22,
    fill: "#262626"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.2918 30.1249C25.8371 30.1249 29.9652 23.8721 29.9652 18.4514C29.9652 18.2756 29.9613 18.096 29.9535 17.9202C30.7566 17.3394 31.4496 16.6201 32 15.796C31.2521 16.1287 30.458 16.346 29.6449 16.4405C30.5011 15.9273 31.1421 15.1211 31.4492 14.1714C30.6438 14.6487 29.763 14.9854 28.8445 15.1671C28.2257 14.5095 27.4075 14.0741 26.5164 13.9283C25.6253 13.7824 24.711 13.9341 23.9148 14.36C23.1186 14.7858 22.4848 15.4621 22.1115 16.2843C21.7382 17.1065 21.6462 18.0287 21.8496 18.9085C20.2187 18.8266 18.6233 18.403 17.1667 17.665C15.71 16.927 14.4247 15.8911 13.3941 14.6245C12.8703 15.5276 12.71 16.5962 12.9459 17.6133C13.1817 18.6303 13.7959 19.5194 14.6637 20.0999C14.0122 20.0792 13.375 19.9038 12.8047 19.5881V19.6389C12.8041 20.5867 13.1317 21.5054 13.7319 22.2389C14.3321 22.9723 15.1678 23.4753 16.0969 23.6624C15.4934 23.8275 14.86 23.8515 14.2457 23.7327C14.5079 24.5477 15.018 25.2606 15.7048 25.7718C16.3916 26.283 17.2209 26.567 18.077 26.5842C16.6237 27.7258 14.8285 28.345 12.9805 28.3421C12.6527 28.3416 12.3253 28.3215 12 28.2819C13.8774 29.4863 16.0613 30.126 18.2918 30.1249Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTw);
export default __webpack_public_path__ + "static/media/tw.5d02ab3cb335a16b4d11bac3d6382030.svg";
export { ForwardRef as ReactComponent };